/**
 * Firebase Helper Utility
 * Handles Firebase operations with fallback to mock data
 */

import { USE_MOCK_DATA } from '../services/mockData';

export const handleFirebaseError = (error, fallback) => {
  console.error('Firebase error:', error);

  // Check if it's a permissions error
  if (error.code === 'permission-denied' || error.message?.includes('permissions')) {
    console.warn('Firebase permissions error detected. Consider using mock data for development.');
    if (fallback) {
      return fallback();
    }
  }

  throw error;
};

export const safeFirebaseQuery = async (firebaseQuery, mockQuery, errorMessage = 'Error fetching data') => {
  try {
    if (USE_MOCK_DATA) {
      return await mockQuery();
    }
    return await firebaseQuery();
  } catch (error) {
    console.error(errorMessage, error);
    // If Firebase fails and we have mock data, use it
    if (mockQuery && (error.code === 'permission-denied' || error.message?.includes('permissions'))) {
      console.warn('Falling back to mock data due to permissions error');
      return await mockQuery();
    }
    throw error;
  }
};

